export const ACCOUNT_STATUS = {
  ALL: 'all',
  VERIFIED: 'verified',
  BLOCKED: 'blocked',
  PAUSED: 'paused',
  RESTRICTED: 'restricted',
  // Set by the payment retry flow when an office's failed charge runs out of
  // retries; lifted when the office selects a new default payment method.
  RESTRICTED_PAYMENTS: 'restricted-payments',
  IN_REVIEW: 'in-review',
  REMOVED: 'removed',
};

export const RAM_VERIFIED_STATUS = {
  ALL: 'all',
  UNVERIFIED: 'unverified',
  FAKE: 'fake',
  VERIFIED: 'verified',
};

export const GOVERNMENT_ID_STATUS = {
  VERIFIED: 'verified',
  UNVERIFIED:'unverified',
  INVALID: 'invalid',
}
